// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Breadcrumb_breadcrumb__xO7VD","link":"Breadcrumb_link__lL8kS","current":"Breadcrumb_current__PgpWC","separator":"Breadcrumb_separator__lvT5Q"};